import { render } from "./HeroiconsOutlineStop.vue?vue&type=template&id=d4bd2d12"
const script = {}

import exportComponent from "/Users/yllndritb/Projects/rent/rent-api/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineStop.vue"]])

export default __exports__